import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

import { SendWithdrawalRequestProps } from 'models/api';

export const sendWithdrawalRequest = createAsyncThunk(
	'funding/sendWithdrawalRequest',
	async (credentials: SendWithdrawalRequestProps, { rejectWithValue }) => {
		try {
			return await AccountService.sendWithdrawalRequest(credentials);
		} catch (e: any) {
			return rejectWithValue(e?.response.data);
		}
	},
);
